import Vue from 'vue';
import Component from 'vue-class-component';

import useCatalogFilters from 'ecommerce/composables/useCatalogFilters';
import { formatTime } from 'common/utils/formatDateTime';

@Component({
  props: {
    availableHours: {
      type: Array,
      required: false,
      default: () => [],
    },
    activitySlug: {
      type: String,
      required: true,
      default: '',
    },
  },
  setup() {
    const {
      onSetSchedule,
      onActivityBySlug,
      onToggleModalReservation,
    } = useCatalogFilters();

    return {
      onSetSchedule,
      onActivityBySlug,
      onToggleModalReservation,
    };
  },
})
export default class ActivityCardHoursComponent extends Vue {
  selectedHour = null;

  showLeftArrow = true;
  showRightArrow = true;
  buttonsContainer = null;
  buttonWidth = null;

  mounted() {
    this.buttonsContainer = this.$refs.buttonsContainer;
    this.buttonWidth = this.$refs.button[0].offsetWidth;

    const intersectionOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    };

    const handleIntersection = (activate, deactivate) => {
      return async ev => (ev[0].isIntersecting ? deactivate() : activate());
    };

    this.startObserver = new IntersectionObserver(
      handleIntersection(
        () => {
          this.showLeftArrow = true;
        },
        () => {
          this.showLeftArrow = false;
        },
      ),
      intersectionOptions,
    );

    this.startObserver.observe(this.$refs.button[0]);

    this.endObserver = new IntersectionObserver(
      handleIntersection(
        () => {
          this.showRightArrow = true;
        },
        () => {
          this.showRightArrow = false;
        },
      ),
      intersectionOptions,
    );

    this.endObserver.observe(this.$refs.button[this.$refs.button.length - 1]);
  }

  scrollLeft() {
    this.buttonsContainer.scrollLeft -= this.buttonWidth + 16;
  }

  scrollRight() {
    this.buttonsContainer.scrollLeft += this.buttonWidth + 16;
  }

  formatTime(time, endTime) {
    return formatTime(time, endTime);
  }

  async selectHour(hour) {
    this.onSetSchedule(hour);
    this.selectedHour = hour;
    await this.onActivityBySlug(this.activitySlug);
    this.onToggleModalReservation();
  }
}
